import { SimpleGuard } from 'interfaces/guards'
import {
  redemptionAccountSelector,
  redemptionItemsDataSelector,
  rewardItemsDataSelector,
  rewardSummarySelector,
  bountyMetaSelector,
  referralInfoSelector,
} from 'selectors/bountySelectors'
import {
  getRedemptionAccountActionCreator,
  getRedemptionsActionCreator,
  getRewardsActionCreator,
  getRewardSummaryActionCreator,
  getReferralInfoActionCreator,
} from 'actions/bountyActions'

export const rewardsGuard: SimpleGuard = {
  name: 'Rewards',
  checker: (state) => Boolean(rewardItemsDataSelector(state)),
  loader: (dispatch) => dispatch(getRewardsActionCreator.request({})),
}

export const redemptionAccountGuard: SimpleGuard = {
  name: 'Redemption Account',
  checker: (state) => redemptionAccountSelector(state) !== null,
  loader: (dispatch) => dispatch(getRedemptionAccountActionCreator.request({})),
}

export const redemptionItemsGuard: SimpleGuard = {
  name: 'Redemption Items',
  checker: (state) => Boolean(redemptionItemsDataSelector(state)),
  loader: (dispatch) => dispatch(getRedemptionsActionCreator.request({})),
}

export const rewardSummaryGuard: SimpleGuard = {
  name: 'Rewards Summary',
  checker: (state) => Boolean(rewardSummarySelector(state) && bountyMetaSelector(state)),
  loader: (dispatch) => dispatch(getRewardSummaryActionCreator.request({})),
}

export const referralInfoGuard: SimpleGuard = {
  name: 'Referral Info',
  checker: (state) => Boolean(referralInfoSelector(state)),
  loader: (dispatch) => dispatch(getReferralInfoActionCreator.request({})),
}
